export enum RouterSlug {
    SITEMAP = 'SITEMAP',
    SEARCH = 'SEARCH',
}
